<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
    persistent
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="primary">
              add
            </v-icon>
          </v-btn>
        </template>
        <span>Attach skills</span>
      </v-tooltip>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Job Description Skills"
      text="Attach skills to job description"
      class="mb-0"
    >
      <form>
        <v-container>
          <v-row>
            <v-col cols="12">              
              <v-autocomplete
                v-model="selectedSkills"          
                v-validate="'required'"
                :loading="loading"
                :items="validSkills"          
                :error-messages="errors.collect('skill')"
                data-vv-name="skill"
                label="Skill"
                placeholder="Skill Attachment"
                item-text="name"
                item-value="id"
                multiple
                hide-no-data
                hide-selected
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="remove(data.item)"
                  >
                    <v-avatar
                      tile
                      left
                    >
                      <img :src="data.item.image_url">
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-avatar tile>
                      <img :src="data.item.image_url">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name" />
                      <v-list-item-subtitle v-html="data.item.category.name" />
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>          
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Attach
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      jobDescriptionId: {
        type: Number,
        default: 0,
      },    
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: null,
        skills: [],
        jobSkills: [],
        selectedSkills: [],
      }
    },
    computed: {
      validSkills () {
        return this.skills.filter(skill => {
          return this.jobSkills.find(jobSkill => jobSkill.id === skill.id) === undefined && skill.levels_count > 0
        })
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.resetForm()

          this.loadData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.jobRequirements().create(this.jobDescriptionId, this.selectedSkills) 
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$snack({ message: response.data.status })
                  this.$emit('added')
                
                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      loadData () {     
        let requests = [
          this.$api.jobRequirements().list(this.jobDescriptionId),
          this.$api.skills().list(),
        ]

        this.loading = true

        Promise.all(requests)
          .then(([jobRequirements, skills]) => {
            this.jobSkills = jobRequirements.data
            this.skills = skills.data

            this.loading = false
          })
      },
      remove (item) {
        const index = this.selectedSkills.findIndex(id => id === item.id)
        if (index >= 0) this.selectedSkills.splice(index, 1)
      },
      resetForm () {
        this.selectedSkills.splice(0, this.selectedSkills.length)
        
        this.$validator.reset()
      },
    },
  }
</script>
